import React from 'react'

export default function Lang({lang,removeLang,id}) {
	return (
		<>
			<li className="remove-list-style"><span>{removeLang && (<button onClick={()=>removeLang(id)}><i class="far fa-trash-alt"></i></button>)}</span>{lang}</li>
		</>
	)
}